export function LoadingSpinner({ small }: { small?: boolean }) {
  const size = small ? 'w-4 h-4' : 'h-8 w-8';

  return (
    <div className="flex items-center justify-center h-full">
      <div className={`animate-spin rounded-full ${size} border-b-2 border-primary`}></div>
    </div>
  );
}
